import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {arrayToMap} from '../atUtils'

export const addUsers = createAction(ActionTypes.USERS_ADD)
export const addUser = (user) => dispatch => dispatch(addUsers([user]))
export const setUsers = createAction(ActionTypes.USERS_SET)
export const setUsersList = users => dispatch => dispatch(setUsers(arrayToMap(users)))

export const removeUsers = createAction(ActionTypes.USERS_REMOVE)
export const removeUser = (userId) => dispatch => dispatch(removeUsers([userId]))

export const addUserGroups = createAction(ActionTypes.USER_GROUPS_ADD)
export const addUserGroup = (userGroup) => dispatch => dispatch(addUserGroups([userGroup]))

export const setUserGroups = createAction(ActionTypes.USER_GROUPS_SET)
export const setUserGroupsList = (userGroups) => dispatch => dispatch(setUserGroups(arrayToMap(userGroups)))

export const addTimeZoneGroups = createAction(ActionTypes.TIME_ZONE_GROUPS_ADD)
export const addTimeZoneGroup = (timeZoneGroup) => dispatch => dispatch(addTimeZoneGroups[timeZoneGroup])

export const setTimeZoneGroups = createAction(ActionTypes.TIME_ZONE_GROUPS_SET)
export const setTimeZoneGroupsList = (timeZoneGroups) => dispatch => dispatch(setTimeZoneGroups(arrayToMap(timeZoneGroups)))

export const addTasks = createAction(ActionTypes.TASKS_ADD)
export const addTask = (task) => dispatch => dispatch(addTasks([task]))

export const removeTasks = createAction(ActionTypes.TASKS_REMOVE)
export const removeTask = (taskId) => dispatch => dispatch(removeTasks([taskId]))
export const clearTasks = createAction(ActionTypes.TASKS_CLEAR)

export const addProjects = createAction(ActionTypes.PROJECTS_ADD)
export const addProject = (project) => dispatch => dispatch(addProjects([project]))

export const removeProjects = createAction(ActionTypes.PROJECTS_REMOVE)
export const removeProject = (projectId) => dispatch => dispatch(removeProjects([projectId]))

export const addCustomers = createAction(ActionTypes.CUSTOMERS_ADD)
export const addCustomer = (customer) => dispatch => dispatch(addCustomers([customer]))

export const removeCustomers = createAction(ActionTypes.CUSTOMERS_REMOVE)
export const removeCustomer = (customerId) => dispatch => dispatch(removeCustomers([customerId]))

export const addWorkflowStatuses = createAction(ActionTypes.WORKFLOW_STATUSES_ADD)
export const addWorkflowStatus = (workflowStatus) => dispatch => dispatch(addWorkflowStatuses([workflowStatus]))

export const setWorkflowStatuses = createAction(ActionTypes.WORKFLOW_STATUSES_SET)
export const setWorkflowStatusesList = (workflowStatuses) => dispatch => dispatch(setWorkflowStatuses(arrayToMap(workflowStatuses)))

export const removeWorkflowStatuses = createAction(ActionTypes.WORKFLOW_STATUSES_REMOVE)
export const removeWorkflowStatus = (workflowStatusId) => dispatch => dispatch(removeWorkflowStatuses([workflowStatusId]))

export const setTypesOfWork = createAction(ActionTypes.TYPES_OF_WORK_SET)
export const setTypesOfWorkList = (typesOfWork) => dispatch => dispatch(setTypesOfWork(arrayToMap(typesOfWork)))

export const setLeaveTypes = createAction(ActionTypes.LEAVE_TYPES_SET)
export const setLeaveTypesList = (leaveTypes) => dispatch => dispatch(setLeaveTypes(arrayToMap(leaveTypes)))


// WEBPACK FOOTER //
// ./web/js/entities/actions.js